import { useMemo } from 'react'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { useClientConfigurationQuery } from '@client-hub/store/api/crs/react'
import { get } from 'lodash'

type AppConfiguration = {
  isLoading: boolean
  mfaEnforced: string
  tosDocLink: string | undefined
  privacyPolicyDocLink: string | undefined
  legalDocumentAcknowledgementText: string
  disclaimerText: string
  serviceDeskUrl: string | undefined
  sso: {
    enabled: boolean | undefined
    loginButtonText: string | undefined
    requiredDomains: string | undefined
  }
  clientSlug: string | undefined
  internalSSODomains?: string
}
const useAppConfiguration = (): AppConfiguration => {
  const { data, isLoading } = useClientConfigurationQuery()
  const hideTosAndPP = get(data, 'app_configuration.features_settings.hide_tos_and_pp', false)
  const ssoSettings = data?.app_configuration.sso_settings

  return useMemo(
    () => ({
      isLoading,
      legalDocumentAcknowledgementText: get(
        data,
        'app_configuration.features_settings.legal_document_acknowledgement_text',
        '',
      ),
      disclaimerText: get(data, 'app_configuration.features_settings.disclaimer_text', ''),
      mfaEnforced: get(data, 'app_configuration.authentication_settings.multi_factor_authentication', 'Optional'),
      tosDocLink: hideTosAndPP || isLoading ? undefined : get(data, 'app_configuration.features_settings.tos_link'),
      privacyPolicyDocLink:
        hideTosAndPP || isLoading ? undefined : get(data, 'app_configuration.features_settings.privacy_policy_link'),
      serviceDeskUrl: get(data, 'app_configuration.features_settings.service_desk_url'),
      sso: {
        enabled: ssoSettings?.sso_enabled,
        loginButtonText: ssoSettings?.sso_login_button_text,
        requiredDomains: ssoSettings?.sso_login_required_domains,
      },
      clientSlug: get(data, 'client_slug'),
      frontendEnvironment: get(data, 'frontend_environment'),
      internalSSODomains: get(data, "internal_sso_domains"),
    }),
    [data, isLoading],
  )
}

export default useAppConfiguration
